import type {
  EmployeeAssignmentDetailModel,
  EmployeeAssignmentModel,
} from 'api/models';

const HOMEOWNER_GROWTH: EmployeeAssignmentModel['assignmentType'] =
  'HomeownerGrowth';

type AssignableUnit = {
  basicInfo?: { unitId?: string };
  employeeAssignments?: EmployeeAssignmentDetailModel[];
};

export function findHomeownerGrowthAssignment(
  units: AssignableUnit[] | undefined,
  homeIds: (string | undefined)[] | undefined,
) {
  const agreementUnits = units?.filter((unit) =>
    homeIds?.includes(unit?.basicInfo?.unitId),
  );

  const searchedUnits = agreementUnits?.length ? agreementUnits : units;

  return searchedUnits
    ?.flatMap((unit) => unit?.employeeAssignments ?? [])
    .find(
      (assignment) =>
        assignment?.employeeAssignment?.assignmentType === HOMEOWNER_GROWTH,
    );
}

type MappedStepLike = {
  property?: { units?: AssignableUnit[] };
  properties?: { units?: AssignableUnit[] }[];
};

export function getAgreementFlowUnits(mappedStep: MappedStepLike | undefined) {
  if (mappedStep?.property) {
    return mappedStep.property.units ?? [];
  }

  return (
    mappedStep?.properties?.flatMap((property) => property?.units ?? []) ?? []
  );
}
